const styles = (theme) => ({
  cardDescription: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  cardActionDescription: {
    padding: theme.spacing(1.25),
  },
});

export default styles;
